export default "__VITE_ASSET__DkjBo$O3__"